import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Header from "../components/Header";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}!`);
      nav(user.role === "owner" ? "/owner" : "/dashboard");
    } catch (e) {
      toast.error(apiErr(e, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="brut-card p-8 bg-white">
          <h1 className="text-3xl font-black mb-1">Welcome back</h1>
          <p className="text-neutral-600 mb-6">Log in to continue your ICSE prep.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Email</Label>
              <Input data-testid="login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="brut-input rounded-none mt-1" />
            </div>
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Password</Label>
              <Input data-testid="login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="brut-input rounded-none mt-1" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={busy}
              className="brut-btn rounded-none w-full bg-[#1A1A1A] text-white hover:bg-[#1A1A1A]">
              {busy ? "Logging in…" : "Log In"}
            </Button>
          </form>
          <p className="mt-6 text-sm">
            New here? <Link to="/signup" className="font-bold underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
